<template>
  <details class="accordion-item">
    <summary
      class="accordion-item__summary"
      :aria-expanded="rotated"
      @click="toggleAccordion"
    >
      <div class="accordion-item__title">
        <c-icon
          v-if="hasIcon"
          :name="iconName"
          size="lg"
          :color="iconColor"
        />
        <p>
          <slot name="title" />
        </p>
      </div>
      <c-icon
        name="accordion-arrow"
        size="lg"
        color="#074E8E"
        :class="{ rotate: rotated }"
        class="accordion-item__icon"
      />
    </summary>
    <c-text
      size="xs"
      weight="400"
      class="accordion-item__text"
      color="#43515A"
    >
      <slot name="text" />
    </c-text>
  </details>
</template>

<script>
import CText from '@atoms/text/text.vue'
import CIcon from '@ions/icon/icon.vue'

export default {
  name: 'accordion-item',
  components: {
    CText,
    CIcon,
  },
  props: {
    hasIcon: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      default: 'accordion-check'
    },
    iconColor: {
      type: String,
      default: '#3A963E'
    }
  },
  data() {
    return {
      rotated: false,
    }
  },
  methods: {
    toggleAccordion() {
      this.rotated = !this.rotated
      this.pushGTM()
    },
    titleContent() {
      const slot = this.$slots.title
      if (slot) {
        const slotContent = slot()
        if (slotContent.length > 0 && slotContent[0].children) {
          return slotContent[0].children
        }
      }
      return ''
    },
    getBreadcrumbValue() {
      const breadcrumb = document.querySelectorAll('.breadcrumb__link')
      const lastBreadcrumb = breadcrumb[breadcrumb.length - 1]
      return lastBreadcrumb?.textContent?.trim() || ''
    },
    pushGTM() {
      window.dataLayer.push({
        event: 'accordion',
        section: this.getBreadcrumbValue() || '',
        name: this.rotated ? `abrir -${this.titleContent()}` : `fechar -${this.titleContent()}`
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.accordion-item {
  border-bottom: 0.063rem solid $light-gray;
  padding: 1.5rem 0;

  &__summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    list-style-type: none;
    cursor: pointer;

    font-weight: 700;
    font-size: 1rem;
    line-height: 130%;

    @include screen-size("xl") {
      font-size: 1.5rem;
    }
  }

  &__title {
    display: grid;
    grid-template-columns: repeat(2, auto);
    align-items: center;
    justify-content: start;
    width: 100%;
    gap: 1.4375rem;
  }

  &__icon {
    transition: transform 0.3s ease;
  }

  &__icon.rotate {
    transform: rotate(180deg);
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-top: 1.5rem;
  }
}
</style>
